import React from 'react'
import { Row, Col, Label, ModalBody, Input } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'

@localized()
class EditReportTemplateCategoryDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = { ...props.reportTemplateCategory }
  }
  renderBody () {
    if (this.props.loading) { return <LoadingIndicator /> }
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Label><Resx name='Common.Name' />: </Label>
            <Validator name='name' value={this.state.name} required maxLength={256}>
              <Input value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
            </Validator>
          </Col>
        </Row>
        <Row>
          <Col>
            <Label><Resx name='Common.LatinName' />: </Label>
            <Validator name='latinName' value={this.state.latinName} required maxLength={256}>
              <Input value={this.state.latinName} onChange={e => this.setState({ latinName: e.target.value })} />
            </Validator>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { loading, updating } = this.props
    const icon = updating ? 'loader bx-spin' : 'save'
    return (
      <ValidationBoundary>
        <BasicHeader title='' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            {this.renderBody()}
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon={icon} {...this.props} onAction={() => this.props.onAction(this.state)} disabled={!isValid || loading || updating} />
        } />
      </ValidationBoundary>
    )
  }
}

export {
  EditReportTemplateCategoryDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editReportTemplateCategory/dialog.js